import { render, staticRenderFns } from "./AutomatorModeSwitch.vue?vue&type=template&id=0ae5a4cc&scoped=true&"
import script from "./AutomatorModeSwitch.vue?vue&type=script&lang=js&"
export * from "./AutomatorModeSwitch.vue?vue&type=script&lang=js&"
import style0 from "./AutomatorModeSwitch.vue?vue&type=style&index=0&id=0ae5a4cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae5a4cc",
  null
  
)

export default component.exports